import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../app/features/auth/services/auth.service';
import { environment } from '../environments/environment';

// Interfaces pour le typage
export interface PerformanceAndTask {
  totalTasks: number;
  completedTasks: number;
  performancePercentage: number;
}

export interface PresenceLog {
  id: number;
  checkInTime: number[];
  checkOutTime: number[] | null;
  latitude: number;
  longitude: number;
}

export interface PresenceHistory {
  logs: PresenceLog[];
  totalWorkedTime: string;
}

export interface InfoDashboard {
  daysPresent: number;
  totalWorkedHours: number;
}

export interface StatusDistribution {
  status: string;
  percentage: number;
}

export interface PropertyWorker {
  id: number;
  prenom: string;
  nom: string;
  telephone: string;
  present: boolean;
}

export interface PropertyWorkersResponse {
  content: PropertyWorker[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  numberOfElements: number;
  size: number;
  number: number;
  sort: {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
  };
  first: boolean;
  empty: boolean;
}

export interface CreateWorkerRequest {
  nom: string;
  prenom: string;
  email: string;
  password: string;
  telephone: string;
  date: string;
  lieunaissance: string;
  adress: string;
  profil: string;
  photo: string;
}

export interface CreateWorkerResponse {
  id: number;
  nom: string;
  prenom: string;
  email: string;
  telephone: string;
  profil: string;
} 

@Injectable({
  providedIn: 'root'
})
export class DetailsWorkerService {
  private baseUrl = environment.apiUrl;
  private endpoints = environment.endpoints;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getPerformanceAndTask(workerId: number): Observable<PerformanceAndTask> {
    const headers = this.authService.getAuthHeaders();
    return this.http.get<PerformanceAndTask>(`${this.endpoints.tasks.dashboard.replace('{executorId}', workerId.toString())}`, { headers });
  }

  getPresenceHistory(workerId: number): Observable<PresenceHistory> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });

    console.log('🌐 Récupération historique de présence via API Pointage:', `${this.endpoints.workers.presenceHistory.replace('{workerId}', workerId.toString())}`);

    return this.http.get<PresenceHistory>(`${this.endpoints.workers.presenceHistory.replace('{workerId}', workerId.toString())}`, { headers });
  }

  getInfoDashboard(workerId: number): Observable<InfoDashboard> {
    const headers = this.authService.getAuthHeaders();
    return this.http.get<InfoDashboard>(`${this.endpoints.workers.dashboard.replace('{workerId}', workerId.toString())}`, { headers });
  }

  getRepartitions(executorId: number): Observable<StatusDistribution[]> {
    const headers = this.authService.getAuthHeaders();
    return this.http.get<StatusDistribution[]>(`${this.endpoints.tasks.statusDistribution.replace('{executorId}', executorId.toString())}`, { headers });
  }

  getPropertyWorkers(propertyId: number, page: number = 0, size: number = 10): Observable<PropertyWorkersResponse> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });

    const url = `${this.endpoints.workers.byProperty.replace('{propertyId}', propertyId.toString())}?page=${page}&size=${size}`;
    console.log('🌐 Récupération workers de la propriété via API Pointage:', url);

    return this.http.get<PropertyWorkersResponse>(url, { headers });
  }

  createWorker(managerId: number, workerData: CreateWorkerRequest): Observable<CreateWorkerResponse> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    });

    const url = `${this.endpoints.workers.create.replace('{managerId}', managerId.toString())}`;
    console.log('🌐 Création worker via API Pointage:', url, workerData);

    return this.http.post<CreateWorkerResponse>(url, workerData, { headers });
  }
}